import { Component, ViewChild, ElementRef, AfterViewInit,EventEmitter,Output } from '@angular/core';
import { NcalayerService } from '../../@core/utils/ncalayer/ncalayer.service';
import { Cell, DefaultEditor, Editor } from 'ng2-smart-table';

@Component({
  template: `
  <input 
            #name
            type="number"
            pattern="\d*"

            maxlength="12"
            [ngClass]="{'err-class': !checkIin(), 'not-err-class': checkIin()}"
            pattern="[0-9]*" 
            class="form-control short-input"
            list="dynmicUserIds"           
            (input)="this.ncalayer.changeIDN($event.target.value)"
            (change)="selected($event.target.value)"
            [name]="cell.getId()"
            [disabled]="!cell.isEditable()"
            [placeholder]="cell.getTitle()"
            (click)="onClickIDN($event)"
            (keyup)="updateValue()"
            (keydown.enter)="onEdited2($event)"
            (keydown.esc)="onStopEditing.emit()"/>
          <datalist id="dynmicUserIds">
            <option *ngFor="let person of personsN" [value]="person.IDN" fullWidth></option>
          </datalist>
       <div [hidden]="true" [innerHTML]="cell.getValue()" #htmlValue></div>
  `,
  styleUrls: ['./payment.component.scss'],
})
export class CustomEditorComponent2 extends DefaultEditor implements AfterViewInit {
  @Output() valueChange :EventEmitter<string> = new EventEmitter();
  @ViewChild('name') name: ElementRef;
  @ViewChild('url') url: ElementRef;
  @ViewChild('htmlValue') htmlValue: ElementRef;
   Name="";
   personsN:any []; 
   selectedPersons:never[];
  constructor( public ncalayer: NcalayerService,) {
    super();
  }

  ngAfterViewInit() {

    this.personsN = JSON.parse(sessionStorage.getItem("persons"));
    if (this.cell.newValue !== '') {
      this.name.nativeElement.value = this.getUrlName();

    }
  }
  onClickIDN(event:any){
    
  }
  selected(arg:any){
    this.valueChange.emit(arg);
  }
  onInput(val: string) {
    this.valueChange.emit(val);

    this.updateValue()
  }
  
  updateValue() {
   // const href = this.url.nativeElement.value;
 if (this.name.nativeElement.value.length > 12) {
      this.name.nativeElement.value = this.name.nativeElement.value.slice(0,12); 
      const name = this.name.nativeElement.value;
    this.cell.newValue = name;
  }
  else {
    const name = this.name.nativeElement.value;
    this.cell.newValue = name;
  
  }
   // const href = this.url.nativeElement.value;
  
  }
  
    checkIin():boolean {
      this.ncalayer.getChangeIDN().subscribe((data: string) => {
      this.Name=data });
      if (this.Name.length != 12) return false;
      if (!(/[0-9]{12}/.test(this.Name))) return false;
      var b1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
      var b2 = [3, 4, 5, 6, 7, 8, 9, 10, 11, 1, 2];
      var a = [];
      var controll = 0;
      for (var i = 0; i < 12; i++) {
          a[i] = parseInt(this.Name.substring(i, i + 1));
          if (i < 11) controll += a[i] * b1[i];
      }
      controll = controll % 11;
      if (controll == 10) {
          controll = 0;
          for (var i = 0; i < 11; i++)
              controll += a[i] * b2[i];
          controll = controll % 11;
      }
      if (controll != a[11])  return false;
      this.updateValue(); 
      return true;
  }
  checkInputNumber(){
  
    if (/^[0-9]+$/.test(this.Name)){
      this.updateValue() 
      return true

    
    }
    else{ 
      return false
   
      
  }
  }
  

  getUrlName(): string {
    return this.htmlValue.nativeElement.innerText;
  }

  getUrlHref(): string {
    return this.htmlValue.nativeElement.querySelector('a').getAttribute('href');
  }
  onEdited2(event:any){
    console.log('event'+event+'ters');
  }
}
